//#region IMPORTS
import { InstoreOrder } from "../../models/instoreOrder";
import { XCircleIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
//#endregion

//#region INTERFACE
interface Props {
  cancelHandler: () => void;
  instoreOrder: InstoreOrder;
  hide?: boolean;
}
//#endregion

export default function InstoreOrdersTableRowActionCancel({
  cancelHandler,
  instoreOrder,
  hide = false,
}: Props) {
  return !hide ? (
    <Fragment>
      <button
        data-tooltip-content="Cancel order?"
        data-tooltip-variant="dark"
        data-tooltip-place="left"
        data-tooltip-id={String(instoreOrder.id) + "cancel"}
        data-tooltip-delay-show={500}
        className="flex items-center gap-4"
      >
        <XCircleIcon
          className="h-5 w-5 text-fuchsia-700 hover:cursor-pointer hover:text-fuchsia-500"
          onClick={cancelHandler}
          type="button"
        />
      </button>
      <Tooltip id={String(instoreOrder.id) + "cancel"} />
    </Fragment>
  ) : null;
}
